<template>
  <div :class="['coupon-stat-card', isMobile ? 'mobile' : '', compact ? 'compact' : '']">
    <q-card flat bordered :class="['stat-card', customClass]">
      <q-card-section class="text-center" :class="{'q-pa-xs': isMobile || compact }">
        <q-icon :name="icon" :color="iconColor" :size="compact ? 'xs' : (isMobile ? 'sm' : 'md')" />
        <div :class="compact ? 'text-body1' : (isMobile ? 'text-subtitle2' : 'text-h6')" class="q-mt-xs stat-value">{{ value }}</div>
        <div class="text-caption" :class="{'text-weight-medium': isMobile || compact}">{{ label }}</div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  iconColor: {
    type: String,
    default: 'primary'
  },
  value: {
    type: [String, Number],
    required: true
  },
  label: {
    type: String,
    required: true
  },
  isMobile: {
    type: Boolean,
    default: false
  },
  compact: {
    type: Boolean,
    default: false
  },
  customClass: {
    type: String,
    default: ''
  }
});
</script>

<style lang="scss" scoped>
.coupon-stat-card {
  .stat-card {
    border-radius: 8px;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #f5f5f5;
      transform: translateY(-2px);
    }
  }
  
  &.mobile .stat-card {
    padding: 8px;
  }
  
  &.compact {
    .stat-card {
      padding: 6px !important;
      min-height: 40px !important;
      
      .q-card__section {
        padding: 6px !important;
      }
      
      .stat-value {
        margin-top: 3px !important;
        margin-bottom: 3px !important;
        font-size: 1rem !important;
        line-height: 1.2 !important;
      }
      
      .text-caption {
        font-size: 0.7rem !important;
        line-height: 1 !important;
      }
    }
  }
}

.body--dark {
  .stat-card:hover {
    background-color: #2a2a2a;
  }
}
</style>
